import React, { useState, useRef, useEffect } from "react";
import "./AddNoteGroup.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import { colorOptions, normalizeColor } from "../../../../utils/colors";
import ColorPicker from "../../../../components/ColorPicker/ColorPicker";

function AddNoteGroup({ createNoteGroup, cancelCreateNoteGroup }) {
  const [name, setName] = useState("");
  const [selectedColor, setSelectedColor] = useState(colorOptions[0]);
  const [showNameError, setShowNameError] = useState(false);

  const handleCreateNoteGroup = () => {
    if (name.trim()) {
      const colorHex = normalizeColor(selectedColor);
      createNoteGroup(name.trim(), colorHex);
      setName("");
      setSelectedColor(colorOptions[0]);
      setShowNameError(false);
    } else {
      setShowNameError(true);
    }
  };

  const inputRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 100); // 100ms delay to ensure DOM is ready
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="add-note-group-content">
      <div className="modal-title">
        <div>Add Note Group</div>
      </div>
      <div className="modal-form">
        <div className="modal-form-title">Name</div>
        <input
          ref={inputRef}
          type="text"
          className="modal-text-input"
          placeholder="Note Group Name (e.g., Ideas, Thoughts)"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (showNameError && e.target.value.trim()) {
              setShowNameError(false);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleCreateNoteGroup();
            }
          }}
        />
        {showNameError && (
          <div className="modal-helper-text">Please enter a group name</div>
        )}

        <div className="modal-form-title">Color</div>
        <div className="color-picker-wrapper">
          <ColorPicker
            selectedColor={selectedColor}
            onColorSelect={setSelectedColor}
          />
        </div>

        <div className="modal-form-buttons">
          <button
            className="modal-button cancel"
            onClick={() => {
              setName("");
              setSelectedColor(colorOptions[0]);
              setShowNameError(false);
              cancelCreateNoteGroup();
            }}
          >
            Cancel
          </button>
          <button className="modal-button save" onClick={handleCreateNoteGroup}>
            Create
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddNoteGroup;
